<template>
    <a href="/nous-contacter" class="localised-phone">
        <span class="icon-picto_tel"></span>
        <div class="text">
            <p class="label">Contactez votre conseiller <span>Grands Espaces</span></p>
            <p>{{showedNumber}}</p>
        </div>
    </a>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {},
        data() {
            return {
                showedNumber: window.GrandsEspaces.phone_swiss
            };
        },
        computed: {},
        mounted() {
            if (!localStorage.GE_Localisation) {
                axios.get('https://ipapi.co/' + window.GrandsEspaces.client_ip + '/json/')
                    .then((response) => {
                        if (response.data.country) {
                            localStorage.setItem('GE_Localisation', response.data.country);

                            if (response.data.country === "FR") {
                                this.showedNumber = window.GrandsEspaces.phone_french;
                            }
                        }
                    });
            } else {
                if (localStorage.GE_Localisation === "FR") {
                    this.showedNumber = window.GrandsEspaces.phone_french;
                }
            }
        },
        methods: {
            callTo() {
                window.location.href = "tel:" + this.showedNumber;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// assets/js/components/LocalisedPhone.vue